"use client"

import styled from "styled-components"
import {
  Badge,
  Card,
  CardHeader,
  List,
  MonoValue,
  Row,
  RowInfo,
  RowMeta,
  RowName,
  RowRight,
  Sparkline,
  Title,
  TitleGroup,
  Subtitle,
} from "./primitives"

const watchlist = [
  { ticker: "AAPL", name: "Apple Inc.", price: "228.52", change: "+1.8%", up: true, trend: [210, 214, 212, 220, 224, 229] },
  { ticker: "NVDA", name: "NVIDIA Corp.", price: "142.10", change: "+3.4%", up: true, trend: [118, 122, 130, 128, 138, 142] },
  { ticker: "TSLA", name: "Tesla Inc.", price: "246.30", change: "-2.1%", up: false, trend: [268, 262, 258, 254, 250, 246] },
  { ticker: "AMZN", name: "Amazon.com", price: "201.85", change: "+0.9%", up: true, trend: [192, 195, 194, 198, 200, 202] },
]

const ChangeCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 4.25rem;
`

export function StockWatchlistCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Watchlist</Title>
          <Subtitle>4 equities tracked</Subtitle>
        </TitleGroup>
        <Badge tone="optimal">3 up</Badge>
      </CardHeader>

      <List>
        {watchlist.map((s) => (
          <Row key={s.ticker}>
            <RowInfo>
              <RowName>
                {s.ticker} <span style={{ color: "var(--color-muted-foreground)", fontWeight: 400 }}>· {s.name}</span>
              </RowName>
              <RowMeta>NASDAQ</RowMeta>
            </RowInfo>
            <RowRight>
              <Sparkline
                points={s.trend}
                color={s.up ? "var(--color-optimal)" : "var(--color-alert)"}
              />
              <ChangeCell>
                <MonoValue>${s.price}</MonoValue>
                <MonoValue $tone={s.up ? "optimal" : "alert"} style={{ fontSize: "0.8125rem" }}>
                  {s.change}
                </MonoValue>
              </ChangeCell>
            </RowRight>
          </Row>
        ))}
      </List>
    </Card>
  )
}

export default StockWatchlistCard
